import RentBlock from './RentBlock';

export { RentBlock };
export default RentBlock;
